import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ParticipantStatusGuard  {

    constructor(private router: Router) { }

    canActivate(
        next: ActivatedRouteSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const participantStatus = next.queryParamMap.get('redirect');
        if (participantStatus === 'unauthorized') {
            const community = next.params.community;
            const registrationId = next.params.id;

            if (!registrationId) {
                const link = [community, 'error'];
                return this.router.createUrlTree(link);
            } else {
                const link = [
                    community,
                    'unauthorized',
                    registrationId,
                ];
                return this.router.createUrlTree(link);
            }
        }

        return true;
    }
}
